import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ConfigRoutingModule } from "./config-routing.module";
import { ConfigComponent } from "./config/config.component";
import { ConfigNodeComponent } from './config/config-node/config-node.component';
import { CommonModule } from "@angular/common";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { _MatSlideToggleRequiredValidatorModule, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { EditingComponent } from './config/editing/editing.component';
import { MenuOpcionesComponent } from './config/home/menu-opciones.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from '@angular/flex-layout';
import { PageNotAuthorizedComponent } from "./page-not-authorized/page-not-authorized.component";
// import { AngularEditorModule } from "@kolkov/angular-editor";
import { QuillModule } from 'ngx-quill'
import { DeleteMenuDialogComponent } from './config/menu/dialog/delete/delete-menu-dialog.component';
import { ImportMenuDialogComponent } from './config/menu/dialog/import/import-menu-dialog.component';
import { DeleteDestinatarioDialogComponent } from './config/destinatarios/dialog/delete/delete-destinatario-dialog.component';

import { MenuComponent } from './config/menu/menu.component';
import { NuevoMenuComponent } from './config/menu/nuevo/nuevo-menu.component';
import { ConfigMenuComponent } from './config/config-menu/config-menu.component';
import { DestinatariosComponent } from './config/destinatarios/destinatarios.component';
import { EditingMenuComponent } from './config/menu/editing/editing-menu.component';
import { DestinatarioComponent } from './config/destinatarios/destinatario/destinatario.component';
import { DestinatariosMenuComponent } from './config/menu/destinatarios/destinatarios-menu.component';
import { MyCustomPaginatorIntl } from './MyCustomPaginatorIntl';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavegacionComponent } from './config/menu/menu-administrator/navegacion.component';
import { FeriadosComponent } from './config/feriados/feriados.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { AsistenteChatComponent } from './config/asistente-chat/asistente-chat.component';
import { BasecomponentsModule } from "../asistente-en-linea/basecomponents/basecomponents.module";
import { GestionDestinatarioComponent } from './config/gestion-destinatario/gestion-destinatario.component';
import { EditarDestinatarioComponent } from './config/gestion-destinatario/editar-destinatario/editar-destinatario.component';
import { AsistenteMenuComponent } from './config/asistente-menu/asistente-menu.component';
import { AsistenteFormularioComponent } from './config/asistente-formulario/asistente-formulario.component';
import { EditarFeriadoDialogComponent } from './config/components/editar-feriado-dialog/editar-feriado-dialog.component';
import { DuplicarFeriadosDialogComponent } from './config/components/duplicar-feriados-dialog/duplicar-feriados-dialog.component';
import { HeaderComponent } from "./config/header/header.component";
import { ConfirmExitDialogComponent } from './config/components/confirm-exit-dialog/confirm-exit-dialog.component';
import { ValidacionesComponent } from './config/validaciones/validaciones.component';
import { ValidacionComponent } from './config/validaciones/validacion/validacion.component';
import { DeleteValidacionDialogComponent } from './config/validaciones/dialog/delete/delete-validacion-dialog.component';
import { ValidacionesMenuComponent } from './config/menu/validaciones/validaciones-menu.component';
import { MatSortModule } from '@angular/material/sort';
import { ImportDestinatarioValidacionDialogComponent } from './config/menu/dialog/importdestval/import-destval-dialog.component';

@NgModule({
    declarations: [
        ConfigComponent,
        DeleteMenuDialogComponent,
        ImportMenuDialogComponent,
        ImportDestinatarioValidacionDialogComponent,
        DeleteDestinatarioDialogComponent,
        DeleteValidacionDialogComponent,
        MenuComponent,
        NuevoMenuComponent,
        EditingMenuComponent,
        ConfigNodeComponent,
        ConfigMenuComponent,
        EditingComponent,
        MenuOpcionesComponent,
        DestinatariosComponent,
        DestinatarioComponent,
        ValidacionesComponent,
        ValidacionComponent,
        DestinatariosMenuComponent,
        ValidacionesMenuComponent,
        PageNotAuthorizedComponent,
        NavegacionComponent,
        FeriadosComponent,
        AsistenteChatComponent,
        GestionDestinatarioComponent,
        EditarDestinatarioComponent,
        AsistenteMenuComponent,
        AsistenteFormularioComponent,
        EditarFeriadoDialogComponent,
        DuplicarFeriadosDialogComponent,
        HeaderComponent,
        ConfirmExitDialogComponent
    ],

    imports: [
        ConfigRoutingModule,
        MatSlideToggleModule,
        _MatSlideToggleRequiredValidatorModule,
        MatButtonModule,
        ReactiveFormsModule,
        BasecomponentsModule,
        CommonModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDialogModule,
        MatToolbarModule,
        MatInputModule,
        MatCardModule,
        MatGridListModule,
        MatMenuModule,
        MatIconModule,
        MatTableModule,
        MatSortModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatOptionModule,
        FormsModule,
        FlexLayoutModule,
        MatRadioModule,
        MatFormFieldModule,
        MatListModule,
        MatPaginatorModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatInputModule,
        MatFormFieldModule,
        MatNativeDateModule,
        // AngularEditorModule
        QuillModule.forRoot(),
    ],
    entryComponents: [
        DeleteMenuDialogComponent,
        ImportMenuDialogComponent,
        ImportDestinatarioValidacionDialogComponent,
        DeleteDestinatarioDialogComponent,
        DeleteValidacionDialogComponent,
        DestinatariosComponent,
        DestinatarioComponent,
        ValidacionesComponent,
        ValidacionComponent,
        DestinatariosMenuComponent,
        ValidacionesMenuComponent
    ],
    providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }],
    exports: [
        ConfigComponent,
    ]

})
export class ConfigModule { }